var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { GetPropertiesDocument } from './query.gql';
/**
 * Hook used by search table to get metadata properties from cache.
 * Data is primed by the main search query.
 */
export function useProperties() {
    const _a = useQuery(GetPropertiesDocument, {
        fetchPolicy: 'cache-only', // Cache should already be primed with the data
    }), { data } = _a, rest = __rest(_a, ["data"]);
    return Object.assign({ properties: (data === null || data === void 0 ? void 0 : data.documentMetadataProperties) || [] }, rest);
}
